import { SortCountry } from '../interface/sort-country';
import { SortCountryLang } from './sort-country-lang';
import { Multicountry } from '../../../../../../shared/interfaces/create-surveys.interface';

export class UnitedStatesFirst implements SortCountry {
  constructor(public readonly countryList: Multicountry[]) {}

  sort(): Multicountry[] {
    return new SortCountryLang(this.countryList, 'US', 'eng').sort();
  }
}
